__webpack_require__.p = "/event/2022/Historical-Map-Ukraine-Crisis/";